var m = require('mithril');
var columnForm = require('../data/components/columnModal');

module.exports = {
  oninit: function(vnode){
    var ctrl = this;
    ctrl.element = vnode.attrs.element;
    ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  },
  view: function (vnode) {
    var ctrl = this;
    if (!Array.isArray(ctrl.element.out_Contains)) {
      ctrl.element.out_Contains = [];
    }
  
    var tables = ctrl.element.out_Contains.slice(0,1).map(function (outEdge) {
      var ds = outEdge.in;
      if (ctrl.element.path) {
        ds.path = [...ctrl.element.path];
      } else {
        ds.path = [];
      }
      if (!Array.isArray(ds.out_Column)) {
        ds.out_Column = [];
      }
      ds.parent = ctrl.element['@rid'];
      return [
        m('table.w-100.mb3.narrow', {
          style: {
            tableLayout: 'fixed'
          }
        },[
          m('tbody', [ 
            ds.out_Column.map(function (col) {
              col.dataset = ds['@rid'];
              col.path = ds.path;
              return m('tr', {
                style:{ 
                  overflow:'hidden'
                }
              }, [
                m('td.bb', col.name),
                m('td.bb', [
                  m('div.f3.tc', [
                    m('i.ion-ios-compose.blue.ph2', {
                      class: '', 
                      onclick: columnForm.editDialogue.bind(columnForm, col, { delete: true, submitCallback: ctrl.parentReinitialize, dashboardCallback: ctrl.parentReinitialize, columnNameRequired: vnode.attrs.columnNameRequired })
                    }),
                    /*m('i.ion-ios-trash.red.ph2', {
                      onclick: columnForm.deleteDialogue.bind(columnForm, col)
                    })*/
                  ])
                ])
              ])
            }), // tr
            m('tr', [
              m('td.bb', 'New Point'),
              m('td.bb', [
                m('div.tc', 
                  {
                    onclick: columnForm.editDialogue.bind(columnForm, {out: ds['@rid'], path: ds.path}, { submitCallback: ctrl.parentReinitialize, columnNameRequired: vnode.attrs.columnNameRequired })
                  }, 
                  [
                    m('i.icon.icon-right.ion-plus.blue')
                  ]
                )  //a
              ]) // td
            ]) // tr
          ]) // tbody
        ]) // table
      ]
    }) // Map Datasets
    return [
      tables,
    ];
  } // end func builderBody
}